import styled, { css, keyframes } from 'styled-components';

export const BoardWb = styled.div`
  flex: 1;
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #2f3f37;
  background-image:
    radial-gradient(
      135% 110% at 50% 45%,
      rgba(255, 255, 255, 0.04) 0%,
      rgba(255, 255, 255, 0) 42%
    ),
    radial-gradient(
      140% 130% at 50% 118%,
      rgba(0, 0, 0, 0.42) 0%,
      transparent 62%
    ),
    linear-gradient(160deg, #36473e 0%, #2d3c34 55%, #26332c 100%);
  box-shadow:
    inset 0 0 0 8px #6b4f2c,
    inset 0 0 0 11px #4a3518,
    inset 0 0 0 12px #2e2010,
    inset 0 0 160px rgba(0, 0, 0, 0.5);

  &::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.18);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.32);
    border-radius: 7px;
    border: 3px solid transparent;
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
  }

  &::before {
    content: '';
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    opacity: 0.05;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='600'%3E%3Cfilter id='c'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/%3E%3CfeColorMatrix type='matrix' values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 .6 0'/%3E%3C/filter%3E%3Crect width='600' height='600' filter='url(%23c)'/%3E%3C/svg%3E");
    background-size: 600px 600px;
    mix-blend-mode: screen;
  }
`;

export const Topbar = styled.div`
  position: relative;
  z-index: 2;
  flex-shrink: 0;
  padding: 22px 34px 6px;
  pointer-events: none;
`;

const swingLeft = keyframes`
  0%   { transform: rotate(0deg); }
  15%  { transform: rotate(-4deg); }
  30%  { transform: rotate(3.5deg); }
  45%  { transform: rotate(-2.5deg); }
  60%  { transform: rotate(2deg); }
  75%  { transform: rotate(-1deg); }
  100% { transform: rotate(0deg); }
`;

const swingRight = keyframes`
  0%   { transform: rotate(0deg); }
  15%  { transform: rotate(4deg); }
  30%  { transform: rotate(-3.5deg); }
  45%  { transform: rotate(2.5deg); }
  60%  { transform: rotate(-2deg); }
  75%  { transform: rotate(1deg); }
  100% { transform: rotate(0deg); }
`;

export const WbVideoWrapper = styled.div`
  position: absolute;
  top: 40px;
  right: 44px;
  z-index: 3;
  width: 240px;
`;

export const WbVideoBox = styled.div<{
  $shake: 'left' | 'right' | null;
  $interactive?: boolean;
}>`
  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 4px;
  overflow: hidden;
  background: #000;
  border: 4px solid #6b4f2c;
  box-shadow:
    0 0 0 2px #4a3518,
    0 0 0 3px #2e2010,
    0 0 0 4px rgba(255, 255, 255, 0.08),
    0 3px 10px rgba(0, 0, 0, 0.45);
  pointer-events: auto;
  transform-origin: 50% 8%;

  ${({ $interactive }) =>
    $interactive &&
    css`
      cursor: pointer;
    `}
  ${({ $shake }) =>
    $shake === 'left' &&
    css`
      animation: ${swingLeft} 0.75s ease-in-out;
    `}
  ${({ $shake }) =>
    $shake === 'right' &&
    css`
      animation: ${swingRight} 0.75s ease-in-out;
    `}

  video,
  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
  }

  video {
    pointer-events: none;
    object-fit: cover;
    object-position: center center;
  }
`;

export const WbVideoCaption = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 15px;
  z-index: 3;
  width: max-content;
  max-width: 320px;
  text-align: center;
  font-family: 'Segoe Print', 'Bradley Hand', 'Comic Sans MS', cursive;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
  line-height: 1.5;
  letter-spacing: 0.4px;
  min-height: 22px;
  white-space: pre-line;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
  pointer-events: none;
`;

export const WbQuestion = styled.div`
  max-width: 640px;
  margin: 0 auto;
  text-align: center;
  font-family: var(--hand);
  font-weight: 700;
  font-size: 30px;
  line-height: 1.2;
  color: #f4f1ea;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.12);
  overflow-wrap: break-word;
  word-break: break-word;
`;

export const WqFrom = styled.span<{ $color: string }>`
  display: block;
  font-size: 20px;
  font-weight: 600;
  margin-top: 6px;
  letter-spacing: 0.5px;
  color: ${({ $color }) => $color};
`;

export const WbNotes = styled.div<{ $minHeight: number }>`
  position: relative;
  flex: 1;
  min-height: ${({ $minHeight }) => $minHeight}px;
  z-index: 1;
`;

export const WbEmpty = styled.div`
  position: absolute;
  top: 42%;
  left: 0;
  right: 0;
  text-align: center;
  pointer-events: none;
`;

export const WbEmptyMsg = styled.div`
  display: inline-block;
  color: rgba(255, 255, 255, 0.5);
  font-family: var(--hand);
  font-size: 30px;
  line-height: 1.3;
  padding: 14px 24px;
  cursor: default;
`;

export const AddFab = styled.button`
  position: absolute;
  left: 34px;
  top: 60px;
  z-index: 5;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.55);
  font-family: var(--hand);
  font-size: 22px;
  padding: 8px 16px;
  border: 1.5px dashed rgba(255, 255, 255, 0.22);
  border-radius: 12px;
  background: none;
  transition: all 0.15s;

  &:hover {
    color: rgba(255, 255, 255, 0.9);
    border-color: rgba(255, 255, 255, 0.4);
    background: rgba(255, 255, 255, 0.05);
  }
`;
